import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      id: 'ssl',
      icon: 'Shield',
      title: '256-bit SSL',
      description: 'Bank-grade encryption'
    },
    {
      id: 'pci',
      icon: 'CreditCard',
      title: 'PCI DSS Compliant',
      description: 'Secure card processing'
    },
    {
      id: 'razorpay',
      icon: 'Zap',
      title: 'Razorpay Secured',
      description: 'Trusted payment gateway'
    },
    {
      id: 'refund',
      icon: 'RotateCcw',
      title: 'Money Back Guarantee',
      description: '100% refund policy'
    }
  ];

  return (
    <div className="bg-surface border border-border rounded-lg p-6 shadow-subtle">
      <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
        <Icon name="ShieldCheck" size={20} className="mr-2 text-success" />
        Security & Trust
      </h3>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {securityFeatures.map((feature) => (
          <div key={feature.id} className="flex items-start space-x-3 p-3 bg-muted rounded-lg">
            <div className="flex-shrink-0 w-8 h-8 bg-success/10 rounded-lg flex items-center justify-center">
              <Icon name={feature.icon} size={16} color="var(--color-success)" />
            </div>
            <div>
              <h4 className="font-medium text-foreground text-sm">{feature.title}</h4>
              <p className="text-xs text-text-secondary mt-1">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Trust Indicators */}
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-center space-x-6 text-xs text-text-secondary">
          <div className="flex items-center">
            <Icon name="Users" size={14} className="mr-1" />
            <span>10,000+ students</span>
          </div>
          <div className="flex items-center">
            <Icon name="Star" size={14} className="mr-1" />
            <span>4.8/5 rating</span>
          </div>
          <div className="flex items-center">
            <Icon name="Award" size={14} className="mr-1" />
            <span>ISO certified</span>
          </div>
        </div>
      </div>

      {/* Contact Support */}
      <div className="mt-4 p-3 bg-primary/5 border border-primary/20 rounded-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Icon name="Headphones" size={16} className="mr-2 text-primary" />
            <span className="text-sm font-medium text-primary">Need Help?</span>
          </div>
          <a 
            href="tel:+91-800-TRAINING" 
            className="text-sm text-primary hover:underline"
          >
            Call Support
          </a>
        </div>
        <p className="text-xs text-primary/80 mt-1">
          Our payment specialists are available 24/7 to assist you
        </p>
      </div>
    </div>
  );
};

export default SecurityBadges;